import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../components/router/router-tabbed-navigation';
import { useCanCreateSweepTarget } from '../../../../../../features/sweeps/sweeps-permission-helpers';
import { SweepTargetCreateDrawer } from '../../../../../../features/sweeps/target/sweep-target-create-drawer';
import { SweepTargetsTable } from '../../../../../../features/sweeps/target/sweep-targets-table';
import { getPageHead } from '../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/sweep/target/_target/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.Sweeps,
      label: 'Targets',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.Sweeps>,
  head: () => getPageHead('Sweep Targets'),
  component: SweepTargetList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const canCreateSweepTarget = useCanCreateSweepTarget();

  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {canCreateSweepTarget ? (
            <RequiresAccess write>
              <SweepTargetCreateDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Sweep Target" size="small" />} />
            </RequiresAccess>
          ) : null}

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.Sweeps}
    />
  );
}

function SweepTargetList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <SweepTargetsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
